import { useMemo } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'src/components/ui';

function SimpleDropdown({
  value: propValue,
  options,
  onSelect,
  style = {},
  toggleStyle = {},
  placeholder = '',
  color = 'secondary',
  direction = 'down',
  noCaret = false,
  menuStyle = {},
}) {
  const current = useMemo(() => options.find(({ value }) => value === propValue), [options, propValue]);

  return (
    <UncontrolledDropdown style={style} direction={direction}>
      <DropdownToggle className="simple-dropdown-toggle" color={color} caret={!noCaret} style={toggleStyle}>
        {current?.title ?? placeholder}
      </DropdownToggle>
      <DropdownMenu style={menuStyle}>
        {options?.map(o => (
          <DropdownItem key={o.value} onClick={() => onSelect(o.value, o)}>
            {o.title}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

export default SimpleDropdown;
